import { DiagramState, icon } from './../types';
import Konva from 'konva';
import { assets } from '../game';
import { COLORS, FONT, TABLE } from '../constants';
import Table from './table';

class ImageStatus {
	options: any = {
		booked: 0,
		name: '',
		soon: false,
		guestName: '',
	};

	origin: any;

	element = new Konva.Group({name: 'imageStatus'});
	nameNode: any;
	bookedNode: any;
	iconNode: any;
	guestNameNode: any;
	diagramNode: any;

	private table: Table;
	private tableShapeNode: any;

	private isIconVisible = false;
	private nameWidth: any;
	private initialTableShapeSize = {
		width: 0,
		height: 0,
	}

	private diagramColors = {
		arcFront: 'green',
		arcBack: 'blue',
	}

	constructor(options = {}, table: Table) {
		this.nameWidth;
		this.options = options;
		this.table = table;
		this.tableShapeNode = table.shape;
		this.origin = this.getTableCenter();
		this.initialTableShapeSize = this.initTableShapeSize();

		this.initDiagram();
		this.setDiagram(DiagramState.hide, 0);
		this.initName(this.options.name);
		this.initGuestName(this.options.guestName);
		this.initBooked(this.options.booked);
		this.initIcon(this.options.soon);
		this.initTimeLabel(this.options.timeLabel);
		// this.updatePositions();
		// this.debug();
		
	}

	debug(){
		let rect = new Konva.Rect({
			x: 0,
			y: 0,
			width: this.element.getClientRect().width,
			height: this.element.getClientRect().height,
			stroke: 'green',
		});
		this.element.add(rect);
	}

	private initTimeLabel(name: string) {
		const text = new Konva.Text({
			x: 0,
			y: 0,
			text: name,
			fontSize: 12,
			fontFamily: FONT.SUBFACE,
			fill: 'black',
			fontStyle: '600',
			align: 'center',
			name: 'timeLabel',
			width: 46
		});

		text.x(this.getTableCenter().x - text.width() / 2);
		text.y(this.getTableCenter().y - text.height() / 2 - 15);

		this.element.add(text);
	}

	private initName(name: string) {
		const group = new Konva.Group();
		const text = new Konva.Text({
			x: 0,
			y: 0,
			text: name,
			fontSize: 14,
			fontFamily: FONT.REGULAR,
			fill: 'black',
			fontStyle: '600',
			align: 'center',
			name: 'text',
		});
		const bg = new Konva.Rect({
			x: 0,
			y: 0,
			width: 28,
			height: 16,
			fill: '#F3F4F7',
			cornerRadius: 20,
		});

		this.nameWidth = text.width();
		this.nameNode = group;

		text.width(bg.width());
		// bg.y(text.y() - ((bg.height() - text.height()) / 2) - 1);
		group.x(this.getTableCenter().x - bg.width() / 2);
		group.y(this.getTableCenter().y - bg.height() / 2);
		text.y(2);

		group.add(bg);
		group.add(text);
		this.element.add(group);
	}

	private initBooked(number: number) {
		const group = new Konva.Group({ width: 14 });
		const text = new Konva.Text({
			x: 0,
			y: 1,
			text: `${number}`,
			fontSize: 12,
			fontFamily: FONT.SUBFACE,
			fill: 'black',
			fontStyle: '600',
			name: 'booked',
			align: 'center',
			width: 14,
		});

		group.add(text);

		group.x(this.getTableCenter().x - text.width() / 2);
		group.y(this.getTableCenter().y - text.height() / 2 + 15);

		this.bookedNode = group;
		this.element.add(group);
	}

	private initIcon(state: boolean) {
		const icon = new Konva.Image({
			x: 0,
			y: 0,
			image: assets.iconClock,
			width: 12,
			height: 12,
		});

		icon.x(this.getTableCenter().x - icon.width() / 2);
		icon.y(this.getTableCenter().y - icon.height() / 2 + 15);

		icon?.hide();
		if (state) {
			icon.show();
		}

		this.iconNode = icon;
		this.element.add(icon);
	}

	private initGuestName(name: string) {
		const tableShape = this.tableShapeNode;
		const tableWidth =
			tableShape.constructor.name == 'Circle'
				? (tableShape.radius() * 2) + 20
				: tableShape.width() + 10;

		const guestName = new Konva.Text({
			x: 0,
			y: 0,
			text: name,
			fontSize: 15,
			fontFamily: FONT.SUBFACE,
			fill: 'black',
			ellipsis: true,
			width: tableWidth,
			wrap: 'none',
		});

		this.guestNameNode = guestName;
		this.element.add(guestName);

		this.updateGuestNamePosition();
	}

	private initDiagram() {
		const group = new Konva.Group();
		const arcFront = new Konva.Arc({
			innerRadius: 0,
			outerRadius: 23,
			angle: 360,
			fill: COLORS.DIAGRAM.EXCEEDING,
			stroke: 'white',
			strokeWidth: 0,
			name: 'arcFront',
		});

		const arcBack = new Konva.Arc({
			innerRadius: 0,
			outerRadius: 23,
			angle: 360,
			fill: COLORS.DIAGRAM.DELAY,
			stroke: 'white',
			strokeWidth: 0,
			name: 'arcBack',
		});

		arcFront.x(this.getTableCenter().x);
		arcFront.y(this.getTableCenter().y);
		arcBack.x(this.getTableCenter().x);
		arcBack.y(this.getTableCenter().y);
		arcFront.rotate(-90);
		arcBack.rotate(-90);

		this.diagramNode = group;

		group.add(arcBack);
		group.add(arcFront);
		this.element.add(group);
	}

	private getTableCenter() {
		const tableWidth = this.initialTableShapeSize.width;
		const tableHeight = this.initialTableShapeSize.height;

		let res = { x: 0, y: 0 };

		res.x = tableWidth / 2;
		res.y = tableHeight / 2;

		return res;
	}

	private initTableShapeSize(){
		const isCircle = this.tableShapeNode.constructor.name == 'Circle';
		const size = {width: 0, height: 0};
		const shape = this.tableShapeNode

		if(isCircle){
			size.width = shape.radius() * 2;
			size.height = shape.radius() * 2;
        } else {
			size.width = shape.width();
			size.height = shape.height();
        }

		return size;
	}

	private updatePositions() {
		const icon = this.iconNode;
		const booked = this.bookedNode;
		const iconX = this.getTableCenter().x - icon.width() / 2 - 5;
		const bookedAndIconShow = this.isIconVisible && this.options.booked > 0;
		const bookedOrIconShow = this.isIconVisible || this.options.booked > 0;

		if (bookedAndIconShow) {
			icon.x(iconX);
			icon.y(this.getTableCenter().y - icon.height() / 2 + 15);
			booked.x(iconX + booked.width() - 5);
			return;
		}
		if (bookedOrIconShow) {
			icon.x(this.getTableCenter().x - icon.width() / 2);
			booked.x(this.getTableCenter().x - booked.width() / 2);
			return;
		}
	}

	private updateGuestNamePosition() {
		const tableAbsolutePosition = this.tableShapeNode.absolutePosition();
		const guestNameNode = this.guestNameNode;
		const textWidth = guestNameNode.getTextWidth();
		const isCircle = this.tableShapeNode.constructor.name == 'Circle';
		const isQuad = this.table.options.form == TABLE.FORMS.QUAD;
		const isMsize = this.table.options.size == TABLE.SIZES.M;
		const isLsize = this.table.options.size == TABLE.SIZES.L;

		const rotation = this.tableShapeNode.rotation() % 360;
		const quadRotation = this.tableShapeNode.rotation() % 90;

		guestNameNode.absolutePosition(tableAbsolutePosition);
		guestNameNode.x(this.getTableCenter().x - textWidth / 2);

		if (isCircle) {
			guestNameNode.y(- 15);
		} else if (isQuad){
			guestNameNode.y(this.getTableCenter().y + 
				Math.min(
					-Math.abs((Math.sin(Math.PI / 180 * (quadRotation + 35)) * this.initialTableShapeSize.width / 2)) - this.initialTableShapeSize.height / 2 + 5
					,
					-this.initialTableShapeSize.height / 2 - 15
				)
			);
		} else {
			guestNameNode.y(this.getTableCenter().y + 
				Math.min(
					-Math.abs((Math.sin(Math.PI / 180 * rotation) * this.initialTableShapeSize.width / 2)) - this.initialTableShapeSize.height / 2 + 10
					,
					-this.initialTableShapeSize.height / 2 - 15
				)
			);

			if(isMsize){
				guestNameNode.y(this.getTableCenter().y + 
					Math.min(
						-Math.abs((Math.sin(Math.PI / 180 * rotation) * this.initialTableShapeSize.width / 2)) - this.initialTableShapeSize.height / 2 + 20
						,
						-this.initialTableShapeSize.height / 2 - 15
					)
				);
			}
			else if(isLsize){
				guestNameNode.y(this.getTableCenter().y + 
					Math.min(
						-Math.abs((Math.sin(Math.PI / 180 * rotation) * this.initialTableShapeSize.width / 2)) - this.initialTableShapeSize.height / 2 + 30
						,
						-this.initialTableShapeSize.height / 2 - 15
					)
				);
			}
		}
	}

	setName(name: string) {
		const text = this.nameNode.find('.text')[0];
		text?.text(name);
	}

	setBooked(number: number, color: string = 'black') {
		this.options.booked = number;
		const node = this.bookedNode.find('.booked')[0];
		if (number <= 0) {
			this.bookedNode?.hide();
			return;
		}

		this.updatePositions();
		this.bookedNode?.show();
		node?.text(`${number}`);
		node?.fill(color);
	}

	setTimeLabel(text: string, color: string = 'black') {
		this.options.timeLabel = text;
		const node: any = this.element.find('.timeLabel')[0];

		if (text == '') {
			node?.hide();
			return;
		}

		text = text?.substring(0, 7);

		node?.show();
		node?.text(`${text}`);
		node?.fill(color);
	}

	setIcon(icon: typeof Image | icon) {
		const hide = () => {
			this.iconNode?.hide();
			this.isIconVisible = false;
			this.updatePositions();
			return;
		}

		const hasInAssets = assets[`${icon}`];

		if (icon == '' || hasInAssets == false) {
			hide();
		}

		if(hasInAssets){
			this.iconNode.image(assets[`${icon}`], icon);
		} else {
			try{
				let img: any = new Image();
				img.src = icon;
				this.iconNode.image(img);
			} catch {
				console.error(`Failed to load image: ${icon}`);
                hide();
                return;
			}
		}

		this.isIconVisible = true;
		this.updatePositions();
		this.iconNode?.show();
	}

	setDiagramColors(arcFront: string, arcBack: string): void{
		this.diagramColors.arcFront = arcFront;
		this.diagramColors.arcBack = arcBack;
	}
	setDiagram(state: DiagramState, progress: number) {
		const arcFront = this.diagramNode.find('.arcFront')[0];
		const arcBack = this.diagramNode.find('.arcBack')[0];

		if (state == DiagramState.hide) {
			arcFront?.hide();
			arcBack?.hide();
			return;
		}

		if (progress < 0 || progress > 1) {
			throw new Error(`Invalid diagram progress: ${progress}`);
		}

		if (state == DiagramState.showFront) {
			arcBack?.show();
			arcFront?.hide();
			arcBack.angle(progress * 360);
			arcBack.fill(this.diagramColors.arcBack);
			return;
		}
		if(state == DiagramState.showBoth){
			arcFront.angle(360 * progress);
			arcFront?.show();
			arcFront.fill(this.diagramColors.arcFront);
	
			arcBack?.show();
			arcBack.angle(360);
			arcBack.fill(this.diagramColors.arcBack);
			return;
		}

	}

	setGuestName(name: string) {
		this.options.guestName = name;
		if (name == '') {
			this.guestNameNode?.hide();
			return;
		}

		this.guestNameNode?.text(name);
		this.updateGuestNamePosition();
		this.guestNameNode?.show();
	}
}

export default ImageStatus;
